import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100%;
`;
export const Div = styled.div`
  padding: 3em 0;

  @media (min-width: 789px) {
    padding: 0 5%;
  }
  @media (min-width: 1100px) {
    max-width: 90%;
    margin: auto;
  }
`;
export const Container = styled.div`
  width: 100%;
  padding: 1em;
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-gap: 35px;

  @media (min-width: 789px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (min-width: 1100px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;
export const Card = styled.div`
  width: 100%;
  margin-bottom: 2em;
  border-radius: 15px;
  background: ${({ themed }) => (themed ? "#0F0E37" : "#ffffff")};
  overflow: hidden;
  position: relative;

  &:hover .overlay {
    opacity: 1;
    pointer-events: visible;
  }

  img {
    width: 100%;
  }
`;
export const Image = styled.div`
  width: 100%;
  height: ${(props) => (props ? "405px" : "384px")};
  overflow: hidden;
`;

export const Text = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 1.3em 0;
  color: ${(props) => (props.color ? props.color : "")};
`;
export const H2 = styled.h2`
  margin: 0;
  margin-bottom: 0.5em;
  font-size: 1.5em;
`;
export const P = styled.p`
  margin: 0;
  margin-bottom: 1.5em;
  font-size: 1em;
`;
